<template >
  <Modal v-bind="$attrs" @cancel="onCancel" @confirm="onConfirm">
    <el-form class="ghost-button-styles" ref="form" :model="pageForm" :rules="rules" label-width="100px">
      <el-form-item label="落地页类型" prop="pageType">
        <el-radio-group v-model="pageForm.pageType">
          <el-radio-button ghost :label="1"> 原生落地页 </el-radio-button>
          <el-radio-button ghost :label="2"> 蹊径性能版 </el-radio-button>
          <el-radio-button ghost :label="0"> 蹊径丰富版 </el-radio-button>
        </el-radio-group>
      </el-form-item>

      <el-form-item label-width="0" prop="selected">
        <el-table
          ref="table"
          v-loading="loading"
          class="common-el-table-styles"
          @selection-change="onSelectionChange"
          @select="onRowSelect"
          @row-click="onTableRowClick"
          border
          height="240"
          :data="pagesData"
          style="width: 100%"
        >
          <el-table-column type="selection" width="50"> </el-table-column>
          <el-table-column prop="page_name" label="落地页名称">
            <template slot="header">
              <div class="col-header-page-name-filter">
                <span>落地页名称</span>
                <el-input style="width: 200px" v-model="searchValue" size="mini" placeholder="输入关键字搜索" />
              </div>
            </template>

            <template slot-scope="{ row }">
              <span>{{ row.page_name }}</span>
              <el-tag v-if="row.grantType === 'grant'">共享</el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="60">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onOpenTab(row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-form-item>
    </el-form>
  </Modal>
</template>
<script>
import { omit } from '@/common/js/just.js'
import { PROMOTED_TYPE } from '@/views/create/gdt/model/project-const.js'

import { getBatchPages } from '@/api/tencent.local.model'
import { getWechatPagesGet, getXijingPages } from '@/api/tencent.model'
import Modal from './modal.vue'

export default {
  components: { Modal },
  inject: ['previewTable', 'parentInstance'],
  data() {
    const tableValidator = (rule, value, callback) => {
      if (!value.length) {
        return callback(new Error('请选择落地页'))
      }
      callback()
    }
    return {
      pageForm: {
        pageType: 2,
        linkNameType: '',
        selected: []
      },
      searchValue: '',

      rules: {
        linkPageType: [{ required: true, message: '请选择落地页类型', trigger: 'change' }],
        linkNameType: [{ required: true, message: '请选择行动按钮', trigger: 'change' }],
        selected: [{ required: true, validator: tableValidator }]
      },
      loading: false,
      allPages: [],
      wecahtPages: [],
      xijingPages: []
    }
  },
  computed: {
    rawForm() {
      return this.previewTable.currentModifyTableRow || {}
    },
    pagesData() {
      const { pageType } = this.pageForm
      const list = [this.allPages, this.wecahtPages, this.xijingPages][pageType]
      return list.filter((p) => p.page_name.includes(this.searchValue))
    },

    supportList() {
      const { landing_page_config } = this.rawForm.creative || {}
      if (!landing_page_config) return false
      return landing_page_config.support_page_type_list
    }
  },
  watch: {
    '$attrs.visible'(v) {
      if (v) {
        this.getPages()
      }
    }
  },
  methods: {
    onConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const newCreative = this.rawForm.creative
          const { selected, pageType } = this.pageForm
          const [page] = selected

          const pageInfo = {
            pageType,
            page_spec: page
          }

          this.$emit('confirm', { ...newCreative, pageInfo })
        }
      })
    },
    onCancel() {
      this.$emit('cancel')
      this.$refs.form.clearValidate()
    },

    onSelectionChange(selected) {
      this.pageForm.selected = selected
    },

    onOpenTab(row) {
      window.open(row.preview_url)
    },
    onRowSelect(selection, row) {
      this.onTableRowClick(row)
    },
    onTableRowClick(row) {
      this.$refs.table.clearSelection()
      this.$nextTick(() => {
        this.$refs.table.toggleRowSelection(row, true)
      })
    },
    getPages() {
      const { account, promotedObject } = this.rawForm.plan
      const { promoted_object_type, promoted_object_id } = promotedObject
      const params = {
        ad_account_id: account.id,
        promoted_object_type,
        promoted_object_id
      }

      let pageRequests = []

      // getBatchPages, getXijingPages 只有安卓、ios的推广目的才能添加promoted_object_id过滤
      if ([PROMOTED_TYPE.MINI_GAME_WECHAT].includes(promoted_object_type)) {
        const xijingParams = omit(params, 'promoted_object_id')
        // 小程序推广目的不请求蹊径丰富版
        pageRequests = [getWechatPagesGet(params), getXijingPages(xijingParams)]
      } else {
        pageRequests = [getWechatPagesGet(params), getXijingPages(params), getBatchPages(params)]
      }

      this.loading = true
      Promise.all(pageRequests)
        .then((data) => {
          const [wecahtPages, xijingPages, allPages] = data
          this.allPages = allPages || []
          this.wecahtPages = wecahtPages
          this.xijingPages = xijingPages
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .col-header-page-name-filter {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
